module.exports = __webpack_public_path__ + "img/arrow-circle-down.c3b52347.svg";